export default "float quadraticIn(float t) {\n  return t * t;\n}\n\n"